import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jpx-459-announcement-banner-via-spa-query');
	},
};
